
import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../../components/ui/Accordian";

const MealAccordion = ({ menu = [] }) => {
  return (
    <div className="space-y-3">
      <h2 className="text-md font-medium text-darkGray">Menu</h2>

      <Accordion type="multiple" className="space-y-6 no-underline">
        {menu.length > 0 ? (
          menu.map((meal, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-lightPrimary rounded-md border-2 border-lightGray no-underline"
            >
              <AccordionTrigger className="px-4 py-2 no-underline text-[16px] font-medium flex flex-row justify-between w-full hover:bg-gray-200 rounded-md">
                <div className="text-primary font-medium">{meal?.meal_type}</div>
                <div className="text-sm ">{`${meal?.start_time} - ${meal?.end_time}`}</div>
              </AccordionTrigger>

              <AccordionContent className="px-4 py-3 space-y-1 text-darkgray">
                {meal?.items
                  ? Object.values(meal.items).map((item, idx) => (
                      <div
                        key={idx}
                        className="flex items-center justify-between"
                      >
                        <span>{item?.meal_name}</span>
                        {!item?.status && (
                          <span className="bg-red-100 text-red-500 text-xs px-2 py-1 rounded-md">
                            Out of Stock
                          </span>
                        )}
                      </div>
                    ))
                  : "No items available"}
              </AccordionContent>
            </AccordionItem>
          ))
        ) : (
          <p className="text-gray-400">No Menu Data</p>
        )}
      </Accordion>
    </div>
  );
};

export default MealAccordion;
